 
<template>
	<div class="profile">
		<div class="wp-title">{{ $t('Complete Your Profile') }}</div>
		<div class="wp-form">
			<el-form :model="form" :rules="rules" label-position="top">
				<el-form-item prop="name" :label="$t('Parent Full Name')">
					<el-input class="wp-input" v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item prop="email" :label="$t('Email Address')">
					<el-input class="wp-input" v-model="form.email"></el-input>
				</el-form-item>
				<el-form-item prop="wechat" :label="$t('Wechat ID')">
					<el-input class="wp-input" v-model="form.wechat"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button class="wp-button primary" @click="submit">{{ $t('Continue') }}</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="round"></div>
	</div>
</template>

<script>
	import { setUserProfile } from '../api';
	import { loadingData } from '../utils';
	import { LoginRedirect } from '../services/redirectService';
	import { setUser } from '../store/user';
	import { getStore, keys } from '../store';
	import i18n from '../locales/i18n';
/*   import { log } from 'shelljs/src/common';  */

	export default {
		name: '',
		data() {
			return {
				form: {
					name: '',
					email: '',
					wechat: '',
				},
				rules: {
					name: [{ required: true, message: i18n.t('Please enter your full name'), trigger: 'blur' }],
					email: [
						{ required: true, message: i18n.t('Please enter your email'), trigger: 'blur' },
						{ type: 'email', message: i18n.t('Please enter the correct email address'), trigger: ['blur', 'change'] },
					],
				},
			};
		},
    methods: {
			submit() {
				loadingData(async () => {
					await setUserProfile(this.form.name, this.form.email, this.form.wechat);
					await setUser();
					LoginRedirect();
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	@media screen and (min-width: @device) {
		.wp-form {
			width: 372px;
		}

		.round {
			position: absolute;
			width: 557px;
			height: 557px;
			left: -168px;
			top: -306px;

			background: #f2f9ff;
			border: 46.6311px solid #f2f9ff;
			box-sizing: border-box;
			border-radius: 666.159px;
			z-index: -1;
		}
	}

	@media screen and (max-width: @device) {
		.wp-form {
			width: 90%;
		}
	}
	.wp-title {
		margin-top: 77px;
	}

	.wp-form {
		margin: 50px auto 0;
	}

	.wp-button {
		margin-top: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/views/Profile.vue